import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] uppercase tracking-wider text-neutral50" }, "Agrupar por", -1)
const _hoisted_3 = ["value", "disabled", "title", "data-testid"]
const _hoisted_4 = ["value"]

import { PRIORITY_GROUP_BY_OPTIONS } from '../composables/usePriorityGrouping'
import type { PriorityGroupBy } from '../composables/usePriorityGrouping'


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityGroupBySelect',
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: false },
    testId: { default: 'priority-payments-group-by' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





function onChange(event: Event): void {
  emit('update:modelValue', (event.target as HTMLSelectElement).value as PriorityGroupBy)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "flex flex-col gap-1",
    "data-testid": _ctx.testId
  }, [
    _hoisted_2,
    _createElementVNode("select", {
      class: "rounded-md border border-lightGray30 bg-white px-2 py-1 text-[13px] text-textPrimary disabled:cursor-not-allowed disabled:opacity-50",
      value: _ctx.modelValue,
      disabled: _ctx.disabled,
      title: _ctx.disabled ? 'A Tabela é plana, ordenada pelo prazo' : undefined,
      "data-testid": `${_ctx.testId}-select`,
      onChange: onChange
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRIORITY_GROUP_BY_OPTIONS), (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})